import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

import DefaultEntityCrud from "components/form/DefaultEntityCrud";
import FormContent from "components/form/FormContent";
import FormRow from "components/form/FormRow";
import TextInput from "components/form/input/TextInput";
import DateInput from "components/form/input/DateInput";
import SelectInput from "components/form/input/SelectInput";
import DebugObjComp from "components/DebugObjComp";
import RodadaPermissionsCard from "components/RodadaPermissionsCard";
import { useRodadaPermissions } from "hooks/useRodadaPermissions";

import RodadaEntity from "entity/Rodada";

import TabelaIntervalos from "../TabelaIntervalos";
import Mesas from "../TabelaMesas";
import HorariosReuniao from "../GeradorHorariosReuniao";

import { Box, Button, Typography, Alert } from "@mui/material";
import { KeyboardReturn } from "@mui/icons-material";
import ImageInput from "components/form/input/ImageInput";
import TabContainer from "components/tabs/TabContainer";
import TabPanel from "components/tabs/TabPanel";
import FormatedTextInput from "components/form/input/FormatedTextInput";
import { useFieldValue } from "components/form/input/NestedField";
import PerfilAutorizado from "components/PerfilAutorizado";
import useNotification from "notification";
import { dateHoraToStringIso } from "util/date";
import PainelConfiguracoes from "./PainelConfiguracoes";
import QuestoesSecundariaEditor from "./Questoes/QuestoesSecundariaEditor";
import PainelProdutos from "./PainelProdutos";
import ConfirmDialog from "components/dialog/ConfirmDialog";
import CopiarInscritosDialog from "../CopiarInscritosDialog";
import DuplicarRodadaDialog from "../DuplicarRodadaDialog";
import { ContentCopy } from "@mui/icons-material";
// import FormatedTextInput from 'components/form/input/FormatedTextInput'

const RodadaFormInter = (props) => {
    const { permissions, uidPerfil, perfil } = useRodadaPermissions();
    const { showWarning } = useNotification();
    const [possiveisReunioes, setPossiveisReunioes] = useFieldValue("possiveisReunioes");
    // const [produtosAdicionados, setProdutosAdicionados] = useFieldValue("produtos");
    const [dataFinal, setDataFinal] = useFieldValue("dataFinal");
    let [perfisAutorizado, setPerfisAutorizado] = useFieldValue('perfisAutorizado');
    // const [confirmationDialog, setConfirmationDialog] = useState(false);
    // const [idsSelecionados, setIdsSelecionados] = useState([]);

    const [tab, setTab] = useState(0);
    const [showImportPrompt, setShowImportPrompt] = useState(false);
    const [openCopiarInscritos, setOpenCopiarInscritos] = useState(false);
    const [openDuplicar, setOpenDuplicar] = useState(false);
    const { dataInicio, tipoAncora, mesas } = props.values;
    const { change } = props.form;

    const [searchParams] = useSearchParams();
    // const searchPainel = searchParams.get("painel")
    const searchUid = searchParams.get("uid");
    const navigate = useNavigate();

    // Detecta se uma rodada acabou de ser criada para oferecer importação de inscritos
    useEffect(() => {
        if (searchUid && sessionStorage.getItem('importar_inscritos_nova_rodada') === 'true') {
            sessionStorage.removeItem('importar_inscritos_nova_rodada');
            setShowImportPrompt(true);
        }
    }, [searchUid]);

    // useEffect(() => {
    //     if (!dataFinal) {
    //         let dAux = new Date(dataInicio);
    //         dAux.setHours(18, 0, 0, 0);
    //         props.form.change("dataFinal", dAux);
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [dataInicio]);
    const mantemPerfil = permissions.isEmpresa ? uidPerfil : null;
    const dateToString = (date) => {
        const formatNde = (d) => (d < 10 ? "0" + d : d);

        let d = new Date(date);
        let dStr =
            d.getFullYear() +
            "-" +
            formatNde(d.getMonth() + 1) +
            "-" +
            formatNde(d.getDate()) +
            "T" +
            formatNde(d.getHours()) +
            ":" +
            formatNde(d.getMinutes());

        return dStr;
    };

    const onChangeDataInicio = (e) => {
        change("dataInicio", e.target.value);

        setPossiveisReunioes([]);

        if (!dataFinal) {
            let dAux = new Date(e.target.value);
            dAux.setHours(18, 0, 0, 0);
            let ds = dateHoraToStringIso(dAux);
            setDataFinal(ds);
        } else if (e.target.value > dataFinal) {
            setDataFinal("");
        }
    };

    const onChangeDataFinal = (e) => {
        change("dataFinal", e.target.value);
        setPossiveisReunioes([]);
    };

    const onChangeTempoReuniao = (e) => {
        let newv = e.target.value;
        if (newv < 0) {
            newv = 0;
        }
        change("tempoReuniao", newv);
        if (possiveisReunioes?.length) {
            showWarning("Esta alteração limpou os horários gerados");
        }
        setPossiveisReunioes([]);
    };

    const onChangeIntervaloReuniao = (e) => {
        let newv = e.target.value;
        if (newv < 0) {
            newv = 0;
        }
        change("intervaloReuniao", newv);
        if (possiveisReunioes?.length) {
            showWarning("Esta alteração limpou os horários gerados");
        }
        setPossiveisReunioes([]);
    };

    useEffect(() => {

        if (mantemPerfil) {
            if (!(perfisAutorizado || {})[(mantemPerfil)]) {

                let cp = { ...(perfisAutorizado || {}) }
                if (!perfisAutorizado) {
                    if (perfil.perfisAutorizadoPadrao) {
                        cp = perfil.perfisAutorizadoPadrao
                    }
                }
                cp[mantemPerfil] = true;


                setPerfisAutorizado(cp)
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mantemPerfil, perfisAutorizado])

    return (
        <>
            {searchUid && (
                <Box sx={{ display: "flex", justifyContent: "center", gap: 1, flexWrap: "wrap", marginTop: 2 }}>
                    <Button
                        startIcon={<KeyboardReturn />}
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            navigate(`/painel-controle?rodada=${searchUid}`);
                        }}
                    >
                        Ir para o painel de controle
                    </Button>
                    <Button
                        startIcon={<ContentCopy />}
                        variant="outlined"
                        color="primary"
                        onClick={() => setOpenDuplicar(true)}
                    >
                        Duplicar Rodada
                    </Button>
                </Box>
            )}
            <FormContent sx={{ m: 1 }}>
                <TabContainer tab={tab} changeTab={setTab}>
                    <TabPanel label="Dados" sx={{ m: 1 }}>
                        <FormRow>

                            <SelectInput
                                sx={{ flex: 0.5 }}
                                name="status"
                                label="STATUS"
                                options={["ATIVO", "CONCLUÍDO", "INATIVO"]}
                                required
                            />
                            <SelectInput
                                sx={{ flex: 0.5 }}
                                name="rodadaPublica"
                                label="RODADA PÚBLICA"
                                options={["SIM", "NÃO"]}
                                required
                            />
                            <TextInput sx={{ flex: 2 }} name="nome" label="NOME DA RODADA" required />
                            <DateInput
                                name="dataInicio"
                                showTime
                                required
                                label="DATA DE INÍCIO"
                                // defaultValue={"DD/MM/AAAA --:--"}
                                inputProps={{
                                    style: { textTransform: "uppercase" },
                                    min: dateToString(new Date()),
                                    step: 300,
                                    max: "9999-12-31T23:59",
                                }}
                                onChange={onChangeDataInicio}
                            />
                            <DateInput
                                name="dataFinal"
                                label="DATA DE FINALIZAÇÃO"
                                showTime
                                required
                                // defaultValue={"DD/MM/AAAA --:--"}
                                inputProps={{
                                    style: { textTransform: "uppercase" },
                                    min: dateToString(dataInicio),
                                    max: "9999-12-31T23:59",
                                }}
                                onChange={onChangeDataFinal}
                            />
                        </FormRow>

                        <FormRow>
                            <TextInput sx={{ flex: 2 }} name="local" label="LOCAL" required />
                            <TextInput
                                type="number"
                                name="tempoReuniao"
                                label="TEMPO PARA CADA REUNIÃO (MIN)"
                                onChange={onChangeTempoReuniao}
                                required
                            />
                            <TextInput
                                type="number"
                                name="intervaloReuniao"
                                label="INTERVALO DA REUNIÃO"
                                onChange={onChangeIntervaloReuniao}
                                required
                            />
                        </FormRow>
                        <HorariosReuniao gerador rodadaUid={searchUid} />

                        <FormRow>
                            <TextInput sx={{ flex: 2 }} name="descricao" label="DESCRIÇÃO" multiline required noUpper />
                        </FormRow>
                        <FormRow sx={{ display: "flex", justifyContent: "space-around" }}>
                            <Box sx={{ flex: 1 }}>
                                <Mesas
                                    nome="mesas"
                                    rotulo="MESAS"
                                    alerta={
                                        (tipoAncora === "Comprador" || tipoAncora === "Vendedor") &&
                                            ((mesas && !mesas.length) || !mesas) ? (
                                            <Typography sx={{ color: "#f00" }}>
                                                Sem mesa o assistente não gera reuniões*
                                            </Typography>
                                        ) : (
                                            <></>
                                        )
                                    }
                                />
                            </Box>

                            <Box sx={{ flex: 3 }}>
                                <TabelaIntervalos
                                    nome="intervalos"
                                    rotulo="INTERVALOS"
                                    dataInicio={dataInicio}
                                    dataFinal={dataFinal}
                                />
                            </Box>
                        </FormRow>
                    </TabPanel>
                    <TabPanel label="Identidade Visual" sx={{ m: 1 }}>
                        <FormRow>
                            <ImageInput
                                name={"capa"}
                                label={"Capa da Rodada"}
                                maxWidth={1600}
                                maxHeight={838}
                                quality={0.99}
                            ></ImageInput>
                        </FormRow>
                        <FormRow>
                            <Typography variant="caption" sx={{ flex: 1 }}>
                                {
                                    "* A dimensão recomendada é 1600X838 (mesma proporção utilizado nas páginas de evento no Facebook)."
                                }
                            </Typography>
                        </FormRow>
                        <FormRow>
                            <FormatedTextInput name="capaCatalogo" label="Capa do Catálogo" />
                        </FormRow>
                    </TabPanel>
                    <TabPanel label="Produtos" sx={{ m: 1 }}>
                        {/* <Produtos
                            nome="produtos"
                            rotulo="Produtos"
                            rodadaValues={props.values}
                            rodadaChange={change}
                            buttonNew
                            // corrigindo erro
                            idsSelecionados={idsSelecionados}
                            setIdsSelecionados={setIdsSelecionados}
                            produtosAdicionados={produtosAdicionados}
                            setProdutosAdicionados={setProdutosAdicionados}
                            confirmationDialog={confirmationDialog}
                            setConfirmationDialog={setConfirmationDialog}
                            {...props}
                        /> */}

                        <PainelProdutos rodada={props.values} />
                    </TabPanel>
                    <TabPanel label="Horários" sx={{ m: 1 }}>
                        <FormRow>
                            <HorariosReuniao rodadaUid={searchUid} />
                        </FormRow>
                    </TabPanel>
                    <TabPanel label="Questões Secundária" sx={{ m: 1 }}>
                        <QuestoesSecundariaEditor />



                    </TabPanel>
                    <TabPanel label="Configurações" sx={{ m: 1 }}>
                        <PainelConfiguracoes dataFinal={dataFinal} dateToString={dateToString} />



                    </TabPanel>
                    {permissions.isEmpresa || permissions.isAdmin ? (
                        <TabPanel label="Usuários" sx={{ m: 1 }}>
                            <PerfilAutorizado name="perfisAutorizado" label="Perfis Autorizados" mantemPerfil={permissions.isEmpresa ? uidPerfil : null} />
                        </TabPanel>
                    ) : null
                    }
                    {/* <TabPanel label="Usuários" sx={{ m: 1 }}>
                        <PerfilAutorizado name="perfisAutorizado" label="Perfis Autorizados" mantemPerfil={permissions.isEmpresa ? uidPerfil : null} />
                    </TabPanel> */}
                </TabContainer>

                <DebugObjComp colection={RodadaEntity.collectionUID} uidObj={props.values.uid} values={props.values} />
            </FormContent>

            {showImportPrompt && (
                <ConfirmDialog
                    title="Importar Inscritos"
                    open={true}
                    onClose={(confirmou) => {
                        setShowImportPrompt(false);
                        if (confirmou) {
                            setOpenCopiarInscritos(true);
                        }
                    }}
                    labelYes="Sim, importar"
                    labelNo="Não"
                >
                    Deseja importar inscritos de outra rodada para esta nova rodada?
                </ConfirmDialog>
            )}

            <CopiarInscritosDialog
                rodadaDestino={props.values}
                open={openCopiarInscritos}
                onClose={() => setOpenCopiarInscritos(false)}
            />

            {openDuplicar && (
                <DuplicarRodadaDialog
                    rodada={props.values}
                    open={true}
                    onClose={(result) => {
                        setOpenDuplicar(false);
                        if (result?.redirect && result?.rodadaUid) {
                            navigate(`/rodada?uid=${result.rodadaUid}`);
                        }
                    }}
                    showRedirect={true}
                />
            )}
        </>
    );
};

export default function RodadaForm() {
    const { permissions, loading, consumirRodada } = useRodadaPermissions();
    const { showWarning, showSuccess } = useNotification();
    const navigate = useNavigate();

    // Intercepta o salvamento para consumir saldo
    const handleBeforeSave = async (values, isNewRecord) => {
        console.log('handleBeforeSave')
        // Se é um novo registro e é empresa, precisa consumir saldo
        if (isNewRecord && permissions.isEmpresa && !permissions.isAdmin) {
            if (!permissions.canCreate) {
                showWarning(permissions.reason);
                return false; // Bloqueia o salvamento
            }
        }

        return true; // Permite o salvamento
    };
    const handleAfterSave = async (values, isNewRecord) => {
        console.log('handleAfterSave', isNewRecord)
        // Se é um novo registro e é empresa, precisa consumir saldo
        if (isNewRecord && permissions.isEmpresa && !permissions.isAdmin) {

            // Consome uma rodada do saldo
            const success = await consumirRodada();
            if (!success) {
                showWarning("Erro ao processar saldo de rodadas. Tente novamente.");
                return false;
            }

            showSuccess("Rodada cadastrada! Saldo atualizado.");
        }

        // Sinaliza para exibir prompt de importação de inscritos após criar nova rodada
        if (isNewRecord) {
            sessionStorage.setItem('importar_inscritos_nova_rodada', 'true');
        }
    };

    // Verifica permissões antes de renderizar o formulário
    if (loading) {
        return (
            <Box sx={{ p: 3, textAlign: 'center' }}>
                <Typography>Verificando permissões...</Typography>
            </Box>
        );
    }

    // Se não tem permissão para criar/editar, mostra alerta
    if (!permissions.canCreate && !permissions.canEdit && !permissions.isAdmin) {
        return (
            <Box sx={{ p: 3 }}>
                <Alert
                    severity="error"
                    action={
                        <Button
                            color="inherit"
                            size="small"
                            onClick={() => navigate('/consulta-rodada')}
                        >
                            Voltar
                        </Button>
                    }
                >
                    {permissions.reason}
                </Alert>
            </Box>
        );
    }

    return (
        <Box>
            {/* Card de Permissões - apenas para empresas */}
            {permissions.isEmpresa && (
                <RodadaPermissionsCard permissions={permissions} loading={false} />
            )}

            <DefaultEntityCrud
                EntityClass={RodadaEntity}
                title={"Rodada"}
                routeForm="rodada"
                backRoute="consulta-rodada"
                formActions={{ novoForm: permissions.canCreate, salvarForm: true, sairForm: true }}
                beforeSave={handleBeforeSave}
                afterSave={handleAfterSave}
            >
                {(props) => {
                    return <RodadaFormInter {...props} />;
                }}
            </DefaultEntityCrud>
        </Box>
    );
}
